import {handleLogout} from "components/utils"; import React, {useEffect, useState} from 'react';

import {VerticalTimeline, VerticalTimelineElement} from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import axios from "axios";
import {RecordView} from "./subCategories/records/RecordView";
import {ProcedureView} from "./subCategories/procedure/ProcedureView";
import {BedView} from "./subCategories/bed/BedView";
import {VisitView} from "./subCategories/visit/VisitView";
import {DischargeView} from "./subCategories/discharge/DischargeView";


export const TimelineView = (props: { cookieEntityQr: string, case: any, doctors: Array<any>, stateTracker: any, editProcedure: any, editVisit: any, caseStatus: string }) => {

    const [loading, setLoading] = useState(false)

    const [auditEntries, setAuditEntries] = useState<Array<any>>([])

    function fetchAuditTrail() {
        axios.get('/api/backend/ipd/case/audit/fetch/all/' + props.cookieEntityQr + "/" + props.case.id)
            .then(resp => {
                console.log(JSON.stringify(resp.data))
                setAuditEntries(resp.data)
            })
            .catch(err => {
                console.error(err); if (err.response && err.response!.status && err.response!.status === 403)  { handleLogout() }
            })
    }

    useEffect(() => {
        if (props.cookieEntityQr && props.case) {
            fetchAuditTrail();
        }
    }, [props.cookieEntityQr, props.case, props.stateTracker])

    return (
        <>
            <VerticalTimeline layout="" lineColor="#5A5A5A">

                {auditEntries.map((entry) => {
                    return <>
                        {entry.type == "SERVICE" &&
                            <RecordView uhid={props.case.uhid} cookieEntityQr={props.cookieEntityQr} key={entry.id} data={entry} reloadMethod={fetchAuditTrail} caseStatus={props.caseStatus} referringDr={props.case && props.case.assignedDr}/>}
                        {entry.type == "PROCEDURE" &&
                            <ProcedureView cookieEntityQr={props.cookieEntityQr} key={entry.id} data={entry} reloadMethod={fetchAuditTrail} editMethod={props.editProcedure} caseStatus={props.caseStatus}/>}
                        {entry.type == "BED" &&
                            <BedView cookieEntityQr={props.cookieEntityQr} key={entry.id} data={entry} reloadMethod={fetchAuditTrail} caseStatus={props.caseStatus}/>}
                        {entry.type == "VISIT" &&
                            <VisitView cookieEntityQr={props.cookieEntityQr} key={entry.id} data={entry} reloadMethod={fetchAuditTrail} editMethod={props.editVisit} caseStatus={props.caseStatus}/>}
                        {props.caseStatus != "ACTIVE" && entry.type == "DISCHARGE_SUMMARY" &&
                            <DischargeView cookieEntityQr={props.cookieEntityQr} data={entry} caseData={props.case}/>}
                    </>
                })}

            </VerticalTimeline>
        </>
    );
}
